/**
 * The demographics API client — parsed through its contract, like the owner report, so a warehouse
 * shape drift surfaces as a failed load rather than a wrong chart.
 */
import { demographicsReportSchema, type DemographicsReport } from '@apuestapr/contracts';

import type { ApiClient, ApiResult } from '../api/client.ts';

export interface DemographicsApi {
  readonly get: (from: string, to: string) => Promise<ApiResult<DemographicsReport>>;
}

export const createDemographicsApi = (client: ApiClient): DemographicsApi => ({
  get: (from, to) =>
    client.get(
      `/api/admin/analytics/demographics?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`,
      demographicsReportSchema,
    ),
});
